import axios from "../../auth/axiosConfig";
import { BulkUploadResponse, CreateVerificationPayload, CreateVerificationResponse, VerificationsResponse } from "./verification.models";
export const VerificationApi = {
	getVerifications: async (page = 1, size = 1000000): Promise<VerificationsResponse> => {
		const response = await axios.get(`/ui/verifications?size=${size}&page=${page}`)
		return response.data;
	},

	createVerification: async (
		payload: CreateVerificationPayload,
	): Promise<CreateVerificationResponse> => {
		try {
			console.log("Making API request to: /ui/verifications");
			console.log("Request payload:", JSON.stringify(payload, null, 2));

			const response = await axios.post("/ui/verifications", payload);

			console.log("Response status:", response.status);
			console.log("Response headers:", response.headers);
			console.log("Success response:", response.data);
			return response.data;
		} catch (error) {
			console.error("API Error:", error);
			let errorMessage = "Failed to create verification";

			if (error.response) {
				console.log("Error response status:", error.response.status);
				console.log("Error response data:", error.response.data);
				errorMessage =
					error.response.data?.message ||
					error.response.data?.detail ||
					`HTTP ${error.response.status}: ${error.response.statusText}`;
			}

			throw new Error(errorMessage);
		}
	},

	bulkUploadVerifications: async (
		file: File
	): Promise<BulkUploadResponse> => {
		try {
			console.log(
				"Making bulk upload request to: /ui/verifications/bulk-upload"
			);
			console.log("File details:", {
				name: file.name,
				size: file.size,
				type: file.type,
			});

			const formData = new FormData();
			formData.append("file", file);

			const response = await axios.post(
				"/ui/verifications/bulk-upload",
				formData,
			);

			console.log("Response status:", response.status);
			console.log("Response headers:", response.headers);
			console.log("Bulk upload success response:", response.data);
			return response.data;
		} catch (error) {
			console.error("Bulk upload error:", error);
			let errorMessage = "Failed to upload verifications";

			if (error.response) {
				console.log("Error response status:", error.response.status);
				console.log("Error response data:", error.response.data);
				errorMessage =
					error.response.data?.message ||
					error.response.data?.detail ||
					`HTTP ${error.response.status}: ${error.response.statusText}`;
			}

			throw new Error(errorMessage);
		}
	},
};
